// PATH: src/components/modules/devtools/lab/api/labApi.js

export async function labListRuns({ limit = 50 } = {}) {
  const res = await fetch(`/api/dev-ide/lab/runs?limit=${encodeURIComponent(limit)}`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function labCreateRun({ goal_text, project_id = null } = {}) {
  const res = await fetch(`/api/dev-ide/lab/runs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ goal_text, project_id }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function labGetRun(run_id) {
  const res = await fetch(`/api/dev-ide/lab/runs/${encodeURIComponent(run_id)}`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function labRunAllSteps(run_id) {
  const res = await fetch(`/api/dev-ide/lab/runs/${encodeURIComponent(run_id)}/run`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function labRunStep(run_id, step) {
  const res = await fetch(`/api/dev-ide/lab/runs/${encodeURIComponent(run_id)}/step`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ step }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function labApplyPatch(run_id, { apply_backend = true, apply_frontend = false, run_sql = false, target_project_id = null } = {}) {
  const res = await fetch(`/api/dev-ide/lab/runs/${encodeURIComponent(run_id)}/apply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ apply_backend, apply_frontend, run_sql, target_project_id }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}


export async function labScanContext(run_id, { project_id = null } = {}) {
  const res = await fetch(`/api/dev-ide/lab/runs/${encodeURIComponent(run_id)}/scan`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(project_id ? { project_id } : {}),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
